import React from "react";

import { NullaryFn } from "@tvg/ts-types/Functional";
import {
  ColorTokens,
  IconButton,
  Paragraph,
  useColorTokens
} from "@tvg/design-system";
import { LinkContainer, IconContainer } from "./styled-components";

interface Props {
  qaLabel?: string;
  to: string;
  linkText: string;
  onClick: NullaryFn<void>;
}

export const SeeAllIconBtn = ({
  qaLabel = "seeAll",
  to,
  linkText,
  onClick
}: Props) => {
  const { content } = useColorTokens() as ColorTokens;

  return (
    <LinkContainer to={to} data-qa-label={`${qaLabel}`}>
      <IconContainer>
        <IconButton
          qaLabel={`${qaLabel}-IconBtn`}
          size="l"
          variant="tertiary"
          iconName="chevronRight"
          tertiaryColor={content.link}
          onPress={onClick}
        />
      </IconContainer>
      <Paragraph
        qaLabel={`${qaLabel}-LinkText`}
        color={content.link}
        fontSize="s"
        fontFamily="bold"
        onPress={onClick}
      >
        {linkText}
      </Paragraph>
    </LinkContainer>
  );
};

export default SeeAllIconBtn;
